/**
 *
 * @type {*|{}}
 *
 * @depend LPWebSocketWrapper
 */
window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
lpTag.taglets.loggosbamtransport = lpTag.taglets.loggosbamtransport || (function loggosbamtransport(window) {

        var transportType = "loggosbamtransport",
            version = "1.0",
            websocketWrapper,
            callCount = 0,
            validCallCount = 0,
            messageErrorCount = 0,
            sendErrorCount = 0,
            websocketCreationCount = 0,
            websocketCloseCount = 0,
            transportAdded = false,
            configured = false,
            taglets = lpTag.taglets;

        var logType = {DEBUG: "DEBUG", INFO: "INFO", ERROR: "ERROR"};

        init();

        /************************PUBLIC METHODS **********************************/

        /**
         * create the internal websocket connection.
         */
        function init() {
            if (!websocketWrapper) {
                websocketWrapper = new taglets.LPWebSocketWrapper();
            }
            if (!websocketWrapper.supported) {
                _info("WebSockets not supported", "init");
            }
        }

        /**
         * Make a request to the server
         * @param request reqest.data should contain an object to be transported to loggos.
         */
        function issueCall(request) {
            callCount++;
            if (isValidRequest(request)) {
                try {
                    websocketWrapper.send(request.data);
                } catch (exc) {
                    sendErrorCount++;
                }
            }
        }

        /**
         * Validates the basic properties of the request
         * @param request with request.data as object
         * @returns {boolean} true if:
         *  1. request.data is an object to be transported to loggs
         *  2. We already have websocket connection open.
         */
        function isValidRequest(request) {
            var valid = false;

            if (request && typeof request.data === 'object' && websocketWrapper.connected()) {
                valid = true;
                validCallCount++;
            }

            return valid;
        }

        /**
         * Set various connection and details regarding logging with this transport.
         *
         * @param configuration
         *  configuration.server, mandatory, should point to the websocket url
         *  configuration.onlogid, mandatory, should have a function to get executed once we have a new logid from loggos server.
         *  configuration.autoReconnect, optional, default true, true/false whether to reconnect upon disconnection from websocket server.
         *  configuration.reconnectTimeout, optional, default 10 seconds.
         *  configuration.maxReconnectAttempt, optional, default 30 minutes.
         *
         *  @return boolean whether configuration was successful or not.
         */
        function configure(configuration) {
            if (!configured) {
                var websocketconf = {
                    server: configuration.server,
                    ping: {
                        request: {type: "PING"},
                        response: "PONG"
                    },
                    idleBeforePing: 30000,
                    closed: function (data) {
                        websocketCloseCount++;
                    },
                    created: function (data) {
                        websocketCreationCount++;
                    },
                    message: function (response) {
                        try {
                            if (response && response.logId) {
                                configuration.onlogid(response.logId); // contact callback and send it the log id.
                            }
                        } catch (ex) {
                            messageErrorCount++;
                        }

                    },
                    autoReconnect: typeof configuration.autoReconnect === 'boolean' ? configuration.autoReconnect : true,
                    reconnectTimeout: isNaN(configuration.reconnectTimeout) ? 10000 : configuration.reconnectTimeout,
                    maxReconnectAttempt: isNaN(configuration.maxReconnectAttempt) ? 180 : configuration.maxReconnectAttempt
                };

                configured = websocketWrapper.configure(websocketconf);
            }
            return configured;
        }

        /**
         * Shorthand for info logs
         * @param msg
         * @param methodName
         * @private
         */
        function _info(msg, methodName) {
            _log(msg, logType.INFO, methodName);
        }

        function isConnected() {
            return websocketWrapper.connected();
        }

        /**
         * Method for logging
         * @param msg
         * @param type
         * @param callingMethod
         */
        function _log(msg, type, callingMethod) {
            if (window.lpTag && lpTag.log) {
                if (typeof msg === 'string' && callingMethod) {
                    msg = callingMethod + ': ' + msg;
                }
                lpTag.log(msg, type, transportType);
            }
        }

        /************************RETURNED OBJECT **********************************/
        var publicAPI = {
            name: transportType,
            version: version,
            issueCall: issueCall,
            isValidRequest: isValidRequest,
            configure: configure,
            isConnected: isConnected,
            inspect: function () {
                return {
                    name: transportType,
                    version: version,
                    callCount: callCount,
                    validCallCount: validCallCount,
                    messageErrorCount: messageErrorCount,
                    sendErrorCount: sendErrorCount,
                    websocketCreationCount: websocketCreationCount,
                    websocketCloseCount: websocketCloseCount,
                    transportAdded: transportAdded,
                    configured: configured
                };
            }
        };

        if (websocketWrapper && websocketWrapper.supported && taglets.lpAjax) {
            try {
                taglets.lpAjax.addTransport(transportType, publicAPI);
                transportAdded = true;
            } catch (exc) {
                transportAdded = false;
            }
        }
        return publicAPI;
    })(window);
